import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import type { PageEventType } from '@unifyapps/defs/types/page';
import { OZT_METHOD_PAGE_EVENTS } from '../components/InterfaceAppIntegrations/component/consts/ozonetel/pageEvents';
import { getPusherMethodPageEvents } from '../components/InterfaceAppIntegrations/component/consts/pusher/pageEvents';
import InterfaceHelper from '../stores/InterfaceStore/helper/InterfaceHelper';
import { appendEventsIfMissing } from './appendEventsIfMissing';

export function appendIntegrationPageEvents({
  interfaceRecord,
  pageEvents,
}: {
  interfaceRecord?: InterfaceEntity;
  pageEvents?: PageEventType[];
}) {
  const pageEventsWithIntegrationExtras = pageEvents ? [...pageEvents] : [];

  if (InterfaceHelper.isOzonetelEnabled(interfaceRecord)) {
    appendEventsIfMissing(pageEventsWithIntegrationExtras, OZT_METHOD_PAGE_EVENTS);
  }

  if (InterfaceHelper.isPusherEnabled(interfaceRecord)) {
    const channels = InterfaceHelper.getPusherConfig(interfaceRecord)?.channels ?? [];
    appendEventsIfMissing(pageEventsWithIntegrationExtras, getPusherMethodPageEvents(channels));
  }

  return pageEventsWithIntegrationExtras;
}
